import LayoutLogin from '~componentes/LayoutLogin.vue';
import LoginCoordenador from './Login.vue';
import LoginFornecedor from './LoginFornecedor.vue';
import LoginPessoaFisica from './LoginPessoaFisica.vue';
import LoginFuncionario from './LoginFuncionario.vue';
import LoginImportacao from './LoginImportacao.vue';
import LoginAcessoEspecial from './LoginAcessoEspecial.vue';
import LoginUsuarioChat from './LoginUsuarioChat.vue';

export default {
  path: '/login',
  component: LayoutLogin,
  children: [
    {
      path: '',
      component: LoginCoordenador,
      name: 'login',
    },
    {
      path: 'fornecedor', 
      component: LoginFornecedor,
      name: 'login.fornecedor',
    },
    {
      path: 'pessoa-fisica',
      component: LoginPessoaFisica,
      name: 'login.pessoaFisica',
    },
    {
      path: 'aluno',
      redirect: { name: 'login.pessoaFisica' },
      name: 'login.aluno',
    },
    {
      path: 'funcionario',
      component: LoginFuncionario,
      name: 'login.funcionario',
    },
    {
      path: 'importacao',
      component: LoginImportacao,
      name: 'login.importacao',
    },
    {
      path: 'acesso-especial',
      component: LoginAcessoEspecial,
      name: 'login.acessoEspecial',
    },
    {
      path: ':token/usuario-chat',
      component: LoginUsuarioChat,
      name: 'login.usuarioChatApp',
    },
    {
      path: 'usuario-chat',
      component: LoginUsuarioChat,
      name: 'login.usuarioChat',
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/login/rotas.js